import React from 'react';

const SvgOpeningTimes = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM8.652 11.247l1.37-1.369a.624.624 0 00.155-.634 7.069 7.069 0 01-.355-2.222A.624.624 0 009.2 6.4H7.022a.624.624 0 00-.622.622c0 5.843 4.735 10.578 10.578 10.578.342 0 .622-.28.622-.622v-2.172a.624.624 0 00-.622-.622 7.098 7.098 0 01-2.222-.355.619.619 0 00-.634.15l-1.37 1.369a9.426 9.426 0 01-4.1-4.1z",
  fillRule: "evenodd"
}));

export default SvgOpeningTimes;